import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

const testimonials = [
  {
    name: "冲浪小陈",
    role: "每天刷梗 3 小时",
    initial: "陈",
    color: "bg-primary-100 text-primary-700",
    text: "以前一个梗要刷三个平台才搞懂前因后果，现在直接看合集就行。后续梗整理得比我自己翻评论区还全。",
  },
  {
    name: "阿柚不加糖",
    role: "表情包收集控",
    initial: "柚",
    color: "bg-secondary-100 text-secondary-700",
    text: "最实用的是每张表情包都标了使用场景，不用再猜这张图到底该什么时候发。相册已经存了两百多张。",
  },
  {
    name: "剪辑师大辉",
    role: "二创视频创作者",
    initial: "辉",
    color: "bg-accent-100 text-accent-800",
    text: "写脚本卡住的时候就来翻二创灵感，那个「一句话接成连续剧」的专题直接给了我一条视频的选题。",
  },
];

export default function Testimonials() {
  return (
    <section className="mx-auto w-full px-4 py-16 md:px-6 md:py-20" aria-labelledby="voice-title">
      <Reveal>
        <SectionHeading
          eyebrow="网友怎么说"
          title={<span id="voice-title">冲浪的人，最有发言权</span>}
          desc="以下是来自站内留言与投稿里的真实反馈，也是我们继续更新的理由。"
          align="center"
        />
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
        {testimonials.map((item, index) => (
          <Reveal key={item.name} delay={index * 80}>
            <figure className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6">
              <div className="flex gap-0.5 text-accent-500" aria-label="五星好评">
                {[0, 1, 2, 3, 4].map((star) => (
                  <i key={star} className="ri-star-fill text-sm" aria-hidden="true"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                「{item.text}」
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-5">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full font-heading text-lg ${item.color}`}>
                  {item.initial}
                </span>
                <div>
                  <p className="font-label text-sm font-medium text-foreground-950">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.role}</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}